angular
  .module("uploadPersonalDocumentDigital.components", [])
  .component("uploadPersonalDocumentDigital", {
    templateUrl:
      "ng/components/uploadPersonalDocumentDigital/uploadPersonalDocumentDigital.view.html",
    bindings: {
      userDaCensire: " = ",
      dealerUser: "<",
      uploadFinish: "&?",
      financialModel: "<",
      upgradeList: "&",
      snapshot: "<",
      portalRunned: "<",
      isPostVendita: "=",
      postVenditaModel: "=",
      isEstero: "<",
      hideCf: '<'
    },
    controllerAs: "uploadPersonalDocumentDigitalCtrl",
    controller: function accordionUploadDocuments(
      FileUploader,
      $configService,
      $rootScope,
      $timeout,
      $typeDomainService,
      Pf,
      $instantService,
      $financialApiService,
      $portalService,
      $simulationService,
      $RichiestePostVenditaService,
      $download
    ) {
      var self = this;
      var listOfDocument;
      self.$onInit = function () {
        self.addDocument = {
          selected: false,
        };
        self.hideListOfElementUploaded = true;
        self.$portalService = $portalService;
        self.enableLoader = false;
        self.visualProgBarDoc = [];
        self.disabeldUploadFront = [];
        self.disabeldUploadBack = [];
        self.mapComuni = $rootScope.comuniMap;
        self.uploadFromSmartphone = true;
        self.vendorPhone = "";
        self.loadingStatus = {
          uploading: false,
          loadingDataFromCerved: false,
          savedDataFromCerved: false,
          loading: false,
          loadingAddressesList: false,
          loadingPfList: false,
          insertingContract: false,
        };
        self.userDaCensire = self.userDaCensire;
        self.documentUpload = [];
        self.dropdown = {
          tipiDocumento: [],
          ulterioriTipiDocumento: [],
        };

        self.getListaDocumenti();

        $timeout(function () {
          if (self.isPostVendita && self.userDaCensire && (typeof self.userDaCensire.uploadMethod == "undefined" || !!!self.userDaCensire.uploadMethod)) {
            self.userDaCensire.uploadMethod = "upload";
          } else if (self.userDaCensire && (typeof self.userDaCensire.uploadMethod == "undefined" || !!!self.userDaCensire.uploadMethod)) {
            self.userDaCensire.uploadMethod = "smartphone";
          }
          self.uploadDocumentSelect = self.userDaCensire.uploadMethod;
          if (self.uploadDocumentSelect === "smartphone") {
            self.uploadFromSmartphone = true;
          } else {
            self.uploadFromSmartphone = false;
          }

          if (self.userDaCensire.documento.idImgDocumentoCfFront) {
            var temp = {
              name: "Tessera Sanitaria Front",
              type: "imgCf",
              selected: false,
              side: "front",
              typeDocument: "CF",
              downloadLink: "",
              cdDoc: "CF",
              id: self.userDaCensire.documento.idImgDocumentoCfFront,
              downloadKey: self.userDaCensire.documento.idImgDocumentoCfFront,
            };

            self.documentUpload.push(temp);
            self.disabeldUploadFront[0] = true;
          }

          if (self.userDaCensire.documento.idImgDocumentoCfBack) {
            var temp = {
              name: "Tessera Sanitaria Back",
              type: "imgCf",
              selected: false,
              side: "back",
              typeDocument: "CF",
              downloadLink: "",
              cdDoc: "CF",
              id: self.userDaCensire.documento.idImgDocumentoCfBack,
              downloadKey: self.userDaCensire.documento.idImgDocumentoCfBack,
            };
            self.documentUpload.push(temp);
            self.disabeldUploadBack[0] = true;
          }
          if (self.userDaCensire && self.userDaCensire.documento && self.userDaCensire.documento.tipo) {
            generateLinkExampleDoc(self.userDaCensire.documento.tipo)
          }

          if (self.userDaCensire.documento.idImgDocumentoFront) {
            var temp = {
              name: "Documento identità Front",
              type: "imgDocument",
              selected: false,
              side: "back",
              typeDocument: self.userDaCensire.documento.tipo,
              downloadLink: "",
              cdDoc: self.userDaCensire.documento.tipo,
              id: self.userDaCensire.documento.idImgDocumentoFront,
              downloadKey: self.userDaCensire.documento.idImgDocumentoFront,
            };
            self.documentUpload.push(temp);
            self.disabeldUploadFront[1] = true;
          }
          if (self.userDaCensire.documento.idImgDocumentoBack) {
            var temp = {
              name: "Documento identità Back",
              type: "imgDocument",
              selected: false,
              side: "back",
              typeDocument: self.userDaCensire.documento.tipo,
              downloadLink: "",
              cdDoc: self.userDaCensire.documento.tipo,
              id: self.userDaCensire.documento.idImgDocumentoBack,
              downloadKey: self.userDaCensire.documento.idImgDocumentoBack,
            };
            self.documentUpload.push(temp);
            self.disabeldUploadBack[1] = true;
          }
          if (self.userDaCensire.documento.idImgDocumentoBackOther) {
            var temp = {
              name: "Documento identità Back",
              type: "imgOtherDocument",
              selected: false,
              side: "back",
              typeDocument: self.userDaCensire.ulterioreDocumento.tipo,
              downloadLink: "",
              cdDoc: self.userDaCensire.ulterioreDocumento.tipo,
              id: self.userDaCensire.documento.idImgDocumentoBackOther,
              downloadKey: self.userDaCensire.documento.idImgDocumentoBackOther,
            };
            self.documentUpload.push(temp);
          }
          if (self.userDaCensire.documento.idImgDocumentoFrontOther) {
            var temp = {
              name: "Documento identità Back",
              type: "imgOtherDocument",
              selected: false,
              side: "front",
              typeDocument: self.userDaCensire.ulterioreDocumento.tipo,
              downloadLink: "",
              cdDoc: self.userDaCensire.ulterioreDocumento.tipo,
              id: self.userDaCensire.documento.idImgDocumentoFrontOther,
              downloadKey:
                self.userDaCensire.documento.idImgDocumentoFrontOther,
            };
            self.documentUpload.push(temp);
          }
          if (self.userDaCensire.documento.idImgSubjectPhoto) {
            var temp = {
              name: "Documento identità Back",
              type: "foto",
              selected: false,
              side: "front",
              typeDocument: "foto",
              downloadLink: "",
              cdDoc: "foto",
              id: self.userDaCensire.documento.idImgSubjectPhoto,
              downloadKey: self.userDaCensire.documento.idImgSubjectPhoto,
            };
            self.documentUpload.push(temp);
          }
        }, 200);
      };
      self.uploader = new FileUploader({
        url: "",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Token:
            "Bearer " + ($configService.getAppConfig().token || "no-token"),
          "App-Name": $rootScope.portalName,
        },
      });

      self.uploadDataFunc = function (item, index, privacy, type, side) {
        var document =
          arguments.length > 3 && arguments[3] !== undefined
            ? arguments[3]
            : false;
        if (item) {
          self.uploadData = item;
        }
        self.typeTempDocument = type;
        self.isPrivacyUpload = privacy;
        self.uploadDocumenti = document;
        self.currentCodeTypeNameIndex = index;
        self.sideUploaded = side;
      };
      self.finalUpload = function (item) {
        console.log("calling finalUpload");
        self.folderPath = "" + new Date().getTime();
        if (self.isPostVendita) {
          var url =
            $configService.getAppConfig().url +
            "/uni/upload/service-infos/POSTVENDITA";
        } else {
          var url =
            $configService.getAppConfig().url +
            "/uni/upload/service-infos/" +
            encodeURIComponent(
              self.financialModel.leasingData.preventivo.anno
            ) +
            "/" +
            encodeURIComponent(
              self.financialModel.leasingData.preventivo.numero
            ) +
            "/FINANCIAL_PD";
        }

        for (var int = 0; int < self.uploader.queue.length; int++) {
          self.uploader.queue[int].url = url;
        }
        self.loadingStatus.uploading = true;
        //self.uploader.uploadAll();
        var fileFront = document.querySelector(
          "#uploadInput_front_" + self.currentCodeTypeNameIndex
        ).files[0];
        var fileBack = document.querySelector(
          "#uploadInput_back_" + self.currentCodeTypeNameIndex
        ).files[0];
        var file;
        if (fileFront) {
          file = fileFront;
        } else {
          file = fileBack;
        }
        var tipo = "";
        if (self.typeTempDocument == "imgCf") {
          tipo = "CF";
        } else if (self.typeTempDocument == "imgDocument") {
          tipo = self.userDaCensire.documento.tipo;
        } else if (self.typeTempDocument == "imgOtherDocument") {
          tipo = self.userDaCensire.ulterioreDocumento.tipo;
        } else {
          tipo = "FOTO";
        }

        var reader = new FileReader();
        var fronte = self.sideUploaded == "front" ? true : false;
        reader.onload = function (event) {
          if (self.isPostVendita) {
            var formData = new FormData();
            jQuery("#uploadInput_front_" + self.currentCodeTypeNameIndex).val(
              ""
            );
            jQuery("#uploadInput_back_" + self.currentCodeTypeNameIndex).val(
              ""
            );
            appendToForm(formData, "file", file);
            appendToForm(formData, "type", "RICHIESTE_CLIENTI");
            appendToForm(formData, "cdDoc", tipo);
            appendToForm(formData, "filename", file.name);
            appendToForm(formData, "idPratica", self.postVenditaModel.id);
            appendToForm(formData, "personal", true);
            appendToForm(formData, "fronte", fronte);
            appendToForm(formData, "cfSoggetto", self.userDaCensire.cf);
            appendToForm(formData, "ndgSoggetto", self.userDaCensire.ndg);
            appendToForm(formData, "checklistType", "PV");

            $financialApiService
              .uploadDocOnPv(formData)
              .then(function (response) {
                if (!response.success) {
                  self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
                  self.disabledForUploadingInProgress = false;
                  if (self.sideUploaded == "front") {
                    self.disabeldUploadFront[
                      self.currentCodeTypeNameIndex
                    ] = false;
                  } else {
                    self.disabeldUploadBack[
                      self.currentCodeTypeNameIndex
                    ] = false;
                  }
                  return;
                }

                $timeout(function () {
                  if (self.typeTempDocument == "imgOtherDocument") {
                    var temp = {
                      name: file.name,
                      type: self.typeTempDocument,
                      selected: false,
                      side: self.sideUploaded,
                      typeDocument: self.userDaCensire.ulterioreDocumento.tipo,
                      downloadLink: "",
                      cdDoc: self.userDaCensire.ulterioreDocumento.tipo,
                      id: response.id,
                      downloadKey: response.downloadKey,
                    };
                  } else {
                    var temp = {
                      name: file.name,
                      type: self.typeTempDocument,
                      selected: false,
                      side: self.sideUploaded,
                      typeDocument: self.userDaCensire.documento.tipo,
                      downloadLink: "",
                      cdDoc:
                        self.typeTempDocument == "imgCf"
                          ? "CF"
                          : self.userDaCensire.documento.tipo,
                      id: response.id,
                      downloadKey: response.downloadKey,
                    };
                  }

                  if (self.sideUploaded == "front") {
                    self.disabeldUploadFront[
                      self.currentCodeTypeNameIndex
                    ] = true;
                  } else {
                    self.disabeldUploadBack[
                      self.currentCodeTypeNameIndex
                    ] = true;
                  }

                  self.documentUpload.push(temp);

                  self.documentUpload = self.documentUpload.filter(function (
                    elem
                  ) {
                    return elem.name != "";
                  });
                  self.disableInput = false;

                  self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
                  if (
                    self.sideUploaded == "front" &&
                    self.typeTempDocument == "imgCf"
                  ) {
                    self.userDaCensire.documento.imgDocumentoCfFront =
                      response.downloadKey;
                    self.userDaCensire.documento.idImgDocumentoCfFront =
                      response.downloadKey;
                  } else if (
                    self.sideUploaded == "back" &&
                    self.typeTempDocument == "imgCf"
                  ) {
                    self.userDaCensire.documento.imgDocumentoCfBack =
                      response.downloadKey;
                    self.userDaCensire.documento.idImgDocumentoCfBack =
                      response.downloadKey;
                  } else if (
                    self.sideUploaded == "front" &&
                    self.userDaCensire.documento.tipo != "" &&
                    self.typeTempDocument != "foto"
                  ) {
                    if (self.typeTempDocument != "imgOtherDocument") {
                      self.userDaCensire.documento.imgDocumentoFront =
                        response.downloadKey;
                      self.userDaCensire.documento.idImgDocumentoFront =
                        response.downloadKey;
                    } else {
                      self.userDaCensire.documento.idImgDocumentoFrontOther =
                        response.downloadKey;
                    }
                  } else if (
                    self.sideUploaded == "back" &&
                    self.userDaCensire.documento.tipo != "" &&
                    self.typeTempDocument != "foto"
                  ) {
                    if (self.typeTempDocument != "imgOtherDocument") {
                      self.userDaCensire.documento.imgDocumentoBack =
                        response.downloadKey;
                      self.userDaCensire.documento.idImgDocumentoBack =
                        response.downloadKey;
                    } else {
                      self.userDaCensire.documento.idImgDocumentoBackOther =
                        response.downloadKey;
                    }
                  } else {
                    self.userDaCensire.documento.idImgSubjectPhoto =
                      response.downloadKey;
                  }

                  $timeout(function () {
                    self.disabledForUploadingInProgress = false;
                  }, 1000);
                }, 40);
              })
              .catch(function (error) {
                self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
                self.disabledForUploadingInProgress = false;
                if (self.sideUploaded == "front") {
                  self.disabeldUploadFront[
                    self.currentCodeTypeNameIndex
                  ] = false;
                } else {
                  self.disabeldUploadBack[
                    self.currentCodeTypeNameIndex
                  ] = false;
                }
              });
          } else {
            var formData = new FormData();
            jQuery("#uploadInput_front_" + self.currentCodeTypeNameIndex).val(
              ""
            );
            jQuery("#uploadInput_back_" + self.currentCodeTypeNameIndex).val(
              ""
            );
            appendToForm(formData, "file", file);
            appendToForm(formData, "type", "FINANCIAL_PD");
            appendToForm(formData, "cdDoc", tipo);
            appendToForm(formData, "filename", file.name);
            appendToForm(
              formData,
              "idPratica",
              self.financialModel.leasingData.id
            );
            appendToForm(formData, "personal", true);
            appendToForm(formData, "fronte", fronte);
            appendToForm(formData, "cfSoggetto", self.userDaCensire.cf);
            appendToForm(
              formData,
              "numeroAnno",
              self.financialModel.leasingData.preventivo.anno
            );
            appendToForm(
              formData,
              "numeroPreventivo",
              self.financialModel.leasingData.preventivo.numero
            );
            appendToForm(formData, "ndgSoggetto", self.userDaCensire.ndg);

            $financialApiService
              .uploadDocOnDigital(formData)
              .then(function (response) {
                if (!response.success) {
                  self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
                  self.disabledForUploadingInProgress = false;
                  if (self.sideUploaded == "front") {
                    self.disabeldUploadFront[
                      self.currentCodeTypeNameIndex
                    ] = false;
                  } else {
                    self.disabeldUploadBack[
                      self.currentCodeTypeNameIndex
                    ] = false;
                  }
                  return;
                }

                $timeout(function () {
                  if (self.typeTempDocument == "imgOtherDocument") {
                    var temp = {
                      name: file.name,
                      type: self.typeTempDocument,
                      selected: false,
                      side: self.sideUploaded,
                      typeDocument: self.userDaCensire.ulterioreDocumento.tipo,
                      downloadLink: "",
                      cdDoc: self.userDaCensire.ulterioreDocumento.tipo,
                      id: response.id,
                      downloadKey: response.downloadKey,
                    };
                  } else {
                    var temp = {
                      name: file.name,
                      type: self.typeTempDocument,
                      selected: false,
                      side: self.sideUploaded,
                      typeDocument: self.userDaCensire.documento.tipo,
                      downloadLink: "",
                      cdDoc:
                        self.typeTempDocument == "imgCf"
                          ? "CF"
                          : self.userDaCensire.documento.tipo,
                      id: response.id,
                      downloadKey: response.downloadKey,
                    };
                  }

                  if (self.sideUploaded == "front") {
                    self.disabeldUploadFront[
                      self.currentCodeTypeNameIndex
                    ] = true;
                  } else {
                    self.disabeldUploadBack[
                      self.currentCodeTypeNameIndex
                    ] = true;
                  }

                  self.documentUpload.push(temp);

                  self.documentUpload = self.documentUpload.filter(function (
                    elem
                  ) {
                    return elem.name != "";
                  });
                  self.disableInput = false;

                  self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
                  if (
                    self.sideUploaded == "front" &&
                    self.typeTempDocument == "imgCf"
                  ) {
                    self.userDaCensire.documento.imgDocumentoCfFront =
                      response.downloadKey;
                    self.userDaCensire.documento.idImgDocumentoCfFront =
                      response.downloadKey;
                  } else if (
                    self.sideUploaded == "back" &&
                    self.typeTempDocument == "imgCf"
                  ) {
                    self.userDaCensire.documento.imgDocumentoCfBack =
                      response.downloadKey;
                    self.userDaCensire.documento.idImgDocumentoCfBack =
                      response.downloadKey;
                  } else if (
                    self.sideUploaded == "front" &&
                    self.userDaCensire.documento.tipo != "" &&
                    self.typeTempDocument != "foto"
                  ) {
                    if (self.currentCodeTypeNameIndex == 1) {
                      self.userDaCensire.documento.imgDocumentoFront =
                        response.downloadKey;
                      self.userDaCensire.documento.idImgDocumentoFront =
                        response.downloadKey;
                    } else {
                      self.userDaCensire.documento.idImgDocumentoFrontOther =
                        response.downloadKey;
                    }
                  } else if (
                    self.sideUploaded == "back" &&
                    self.userDaCensire.documento.tipo != "" &&
                    self.typeTempDocument != "foto"
                  ) {
                    if (self.currentCodeTypeNameIndex == 1) {
                      self.userDaCensire.documento.imgDocumentoBack =
                        response.downloadKey;
                      self.userDaCensire.documento.idImgDocumentoBack =
                        response.downloadKey;
                    } else {
                      self.userDaCensire.documento.idImgDocumentoBackOther =
                        response.downloadKey;
                    }
                  } else {
                    self.userDaCensire.documento.idImgSubjectPhoto =
                      response.downloadKey;
                  }

                  $timeout(function () {
                    self.disabledForUploadingInProgress = false;
                  }, 1000);
                }, 40);
              })
              .catch(function (error) {
                self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
                self.disabledForUploadingInProgress = false;
                if (self.sideUploaded == "front") {
                  self.disabeldUploadFront[
                    self.currentCodeTypeNameIndex
                  ] = false;
                } else {
                  self.disabeldUploadBack[
                    self.currentCodeTypeNameIndex
                  ] = false;
                }
              });
          }
        };
        if (file) {
          reader.readAsArrayBuffer(file);
        }
      };

      self.generateDownloadLink = function (file) {
        if (self.isPostVendita) {
          var input = {
            downloadKey: file.downloadKey,
          };
          var url = "/uni/downloadDocPv/service-infos/";
          $download.getGenericDownload(url, input).then(function (response) {
            console.log(response);
          });

        } else {
          if (file.zipMode) {
            return (
              $configService.getUrl() +
              "/uni/downloadGenericDigital/service-infos/FINANCIAL_PD/" +
              encodeURIComponent(file.cdDoc) +
              "/zip/" +
              encodeURIComponent(self.financialModel.idWfInstance) +
              "/?token=" +
              $configService.getAppConfig().token
            );
          } else {
            var input = {
              downloadKey: file.downloadKey,
            };
            var url = "/uni/downloadDocDigital/service-infos/";
            $download.getGenericDownload(url, input).then(function (response) {
              console.log(response);
            });
          }
        }
      };
      self.uploader.onWhenAddingFileFailed = function (
        item /*{File|FileLikeObject}*/,
        filter,
        options
      ) {
        console.info("onWhenAddingFileFailed", item, filter, options);
      };

      self.uploader.onAfterAddingFile = function (fileItem) {
        self.disabledForUploadingInProgress = true;
        console.log("fileItem", fileItem);
        self.progresso = 0;
        if (fileItem.file.size > 26214400) {
          $rootScope.$broadcast("addAlert", {
            text: "MAXIMUM_FILE_SIZE_EXCEEDED",
          });
          fileItem.remove();
          jQuery("#uploadInput_back_" + self.currentCodeTypeNameIndex).val("");
          jQuery("#uploadInput_front_" + self.currentCodeTypeNameIndex).val("");
        }
        var fileName = fileItem.file.name;
        if (
          fileName.toLowerCase().indexOf(".png") > -1 ||
          fileName.toLowerCase().indexOf(".jpg") > -1 ||
          fileName.toLowerCase().indexOf(".jpeg") > -1 ||
          fileName.toLowerCase().indexOf(".tiff") > -1 ||
          fileName.toLowerCase().indexOf(".pdf") > -1 ||
          fileName.toLowerCase().indexOf(".zip") > -1
        ) {
          self.uploader.queue[0].progress = 100;

          self.visualProgBarDoc[self.currentCodeTypeNameIndex] = true;

          $timeout(function () {
            self.progresso = 100;
          }, 500);
        } else {
          fileItem.remove();
          jQuery("#uploadInput_back_" + self.currentCodeTypeNameIndex).val("");
          jQuery("#uploadInput_front_" + self.currentCodeTypeNameIndex).val("");
          $rootScope.$broadcast("addAlert", {
            text: "FORMAT_NOT_SUPPORTED",
          });
          self.disabledForUploadingInProgress = false;
        }
      };

      self.uploader.onAfterAddingAll = function (addedFileItems) {
        console.info("onAfterAddingAll", addedFileItems);
        self.finalUpload(self.uploadData);
      };

      self.uploader.onBeforeUploadItem = function (item) {
        item.file.name = window.encodeURIComponent(item.file.name);
        item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
        self.disableInput = true;
      };

      self.uploader.onProgressItem = function (fileItem, progress) {
        self.uploadCompleted = false;
      };

      self.uploader.onProgressAll = function (progress) { };

      self.uploader.onSuccessItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        self.loadingStatus.uploading = false;
      };

      self.uploader.onErrorItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        console.info("onErrorItem", fileItem, response, status, headers);
        self.loadingStatus.uploading = false;
        jQuery("#uploadInput_back_" + self.currentCodeTypeNameIndex).val("");
        jQuery("#uploadInput_front_" + self.currentCodeTypeNameIndex).val("");
        $rootScope.$broadcast("addAlert", {
          text: "ERROR_UPLOADING_FILE",
        });

        self.disableInput = false;
        $timeout(function () {
          self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
        }, 4000);

        fileItem.remove();
        jQuery("#uploadInput_back_" + self.currentCodeTypeNameIndex).val("");
        jQuery("#uploadInput_front_" + self.currentCodeTypeNameIndex).val("");
      };

      self.uploader.onCancelItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        console.log(status);
      };

      self.uploader.onCompleteItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        console.info("onCompleteItem", fileItem, response, status, headers);
        if (
          response &&
          response.uploadFileServicePojo &&
          response.uploadFileServicePojo.success
        ) {
          self.uploadOk = true;
          console.log(fileItem);
          var temp = {
            name: response.uploadFileServicePojo.fileName,
            type: self.typeTempDocument,
            selected: false,
            side: self.sideUploaded,
            typeDocument: self.userDaCensire.documento.tipo,
            downloadLink: self.generateDownloadLink(
              response.uploadFileServicePojo.fileName
            ),
          };

          if (self.sideUploaded == "front") {
            self.disabeldUploadFront[self.currentCodeTypeNameIndex] = true;
          } else {
            self.disabeldUploadBack[self.currentCodeTypeNameIndex] = true;
          }

          self.documentUpload.push(temp);
          self.documentUpload = self.documentUpload.filter(function (elem) {
            return elem.name != "";
          });
        }
        self.uploader.queue = [];

        self.disableInput = false;
        $timeout(function () {
          self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;

          self.disabledForUploadingInProgress = false;
        }, 4000);
        jQuery("#uploadInput_back_" + self.currentCodeTypeNameIndex).val("");
        jQuery("#uploadInput_front_" + self.currentCodeTypeNameIndex).val("");
      };

      self.uploader.onCompleteAll = function () {
        console.info("onCompleteAll");
        self.uploadCompleted = true;
      };

      self.uploader.onSuccessItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        self.uploading = false;
      };

      self.deletePrivacyDocument = function (
        type,
        index,
        fromChangeTypeDocument
      ) {
        self.typeTempDocument = type;
        self.progresso = 100;
        if (type == "all" && self.documentUpload.length) {
          self.visualProgBarDoc[0] = true;
          self.visualProgBarDoc[1] = true;
          var temp = self.documentUpload;
        } else {
          self.visualProgBarDoc[index] = true;
          var temp = self.documentUpload.filter(function (elem) {
            return elem.selected == true && elem.type == type;
          });
        }

        $timeout(function () {
          self.progresso = 0;
        }, 200);

        var documentRow =
          arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        temp.forEach(function (element) {
          if (self.isPostVendita) {
            $simulationService
              .deleteChecklistFilePv(element.downloadKey)
              .then(function (response) {
                console.log(response);
                if (response.success) {
                  self.userDaCensire.documentiCaricati = false;
                  if (type == "all") {
                    self.documentUpload = [];
                    self.disabeldUploadFront[0] = false;
                    self.disabeldUploadBack[0] = false;
                    self.disabeldUploadFront[1] = false;
                    self.disabeldUploadBack[1] = false;
                    self.userDaCensire.documento.imgDocumentoCfFront = "";
                    self.userDaCensire.documento.imgDocumentoCfBack = "";
                    self.userDaCensire.documento.idImgDocumentoCfFront = "";
                    self.userDaCensire.documento.idImgDocumentoCfBack = "";
                    self.userDaCensire.documento.imgDocumentoBack = "";
                    self.userDaCensire.documento.imgDocumentoFront = "";
                    self.userDaCensire.documento.idImgDocumentoFront = "";
                    self.userDaCensire.documento.idImgDocumentoBack = "";
                    self.visualProgBarDoc[0] = false;
                    self.visualProgBarDoc[1] = false;
                  } else {
                    self.documentUpload = self.documentUpload.filter(function (
                      elem
                    ) {
                      return elem.selected != true || elem.type != type;
                    });

                    self.uploadOk = false;
                    if (fromChangeTypeDocument) {
                      self.disabeldUploadFront[index] = false;
                      self.disabeldUploadBack[index] = false;
                    } else {
                      if (temp.length > 1) {
                        self.disabeldUploadFront[index] = false;
                        self.disabeldUploadBack[index] = false;
                        if (index == 0) {
                          self.userDaCensire.documento.imgDocumentoCfFront = "";
                          self.userDaCensire.documento.imgDocumentoCfBack = "";
                          self.userDaCensire.documento.idImgDocumentoCfFront =
                            "";
                          self.userDaCensire.documento.idImgDocumentoCfBack =
                            "";
                        } else if (index == 1) {
                          self.userDaCensire.documento.imgDocumentoBack = "";
                          self.userDaCensire.documento.imgDocumentoFront = "";
                          self.userDaCensire.documento.idImgDocumentoFront = "";
                          self.userDaCensire.documento.idImgDocumentoBack = "";
                        } else {
                          self.userDaCensire.documento.idImgDocumentoFrontOther =
                            "";
                          self.userDaCensire.documento.idImgDocumentoBackOther =
                            "";
                        }
                      } else {
                        if (temp[0].side && temp[0].side == "front") {
                          self.disabeldUploadFront[index] = false;
                          if (index == 0) {
                            if (
                              self.postVenditaModel &&
                              self.postVenditaModel.applicationName ==
                              "AGGIORNAMENTO_DOC_IDENTITA"
                            ) {
                              self.userDaCensire.documento.imgDocumentoFront =
                                "";
                              self.userDaCensire.documento.idImgDocumentoFront =
                                "";
                            } else {
                              self.userDaCensire.documento.imgDocumentoCfFront =
                                "";
                              self.userDaCensire.documento.idImgDocumentoCfFront =
                                "";
                            }
                          } else if (index == 1) {
                            self.userDaCensire.documento.imgDocumentoFront = "";
                            self.userDaCensire.documento.idImgDocumentoFront =
                              "";
                          } else {
                            self.userDaCensire.documento.idImgDocumentoFrontOther =
                              "";
                          }
                        } else {
                          self.disabeldUploadBack[index] = false;
                          if (index == 0) {
                            if (
                              self.postVenditaModel &&
                              self.postVenditaModel.applicationName ==
                              "AGGIORNAMENTO_DOC_IDENTITA"
                            ) {
                              self.userDaCensire.documento.imgDocumentoBack =
                                "";
                              self.userDaCensire.documento.idImgDocumentoBack =
                                "";
                            } else {
                              self.userDaCensire.documento.imgDocumentoCfBack =
                                "";
                              self.userDaCensire.documento.idImgDocumentoCfBack =
                                "";
                            }
                          } else if (index == 1) {
                            self.userDaCensire.documento.imgDocumentoBack = "";
                            self.userDaCensire.documento.idImgDocumentoBack =
                              "";
                          } else {
                            self.userDaCensire.documento.idImgDocumentoBackOther =
                              "";
                          }
                        }
                      }
                    }
                  }
                }
                if (type == "all") {
                  self.visualProgBarDoc[0] = false;
                  self.visualProgBarDoc[1] = false;
                } else {
                  self.visualProgBarDoc[index] = false;
                }
              })
              .catch(function (error) {
                $rootScope.$broadcast("addAlert", {
                  text: "ERROR_TEC",
                });
              });
          } else {
            $simulationService
              .deleteChecklistFileDigital(element.downloadKey)
              .then(function (response) {
                console.log(response);
                if (response.success) {
                  self.userDaCensire.documentiCaricati = false;
                  if (type == "all") {
                    self.documentUpload = [];
                    self.disabeldUploadFront[0] = false;
                    self.disabeldUploadBack[0] = false;
                    self.disabeldUploadFront[1] = false;
                    self.disabeldUploadBack[1] = false;
                    self.userDaCensire.documento.imgDocumentoCfFront = "";
                    self.userDaCensire.documento.imgDocumentoCfBack = "";
                    self.userDaCensire.documento.idImgDocumentoCfFront = "";
                    self.userDaCensire.documento.idImgDocumentoCfBack = "";
                    self.userDaCensire.documento.imgDocumentoBack = "";
                    self.userDaCensire.documento.imgDocumentoFront = "";
                    self.userDaCensire.documento.idImgDocumentoFront = "";
                    self.userDaCensire.documento.idImgDocumentoBack = "";
                    self.visualProgBarDoc[0] = false;
                    self.visualProgBarDoc[1] = false;
                  } else {
                    self.documentUpload = self.documentUpload.filter(function (
                      elem
                    ) {
                      return elem.selected != true || elem.type != type;
                    });

                    self.uploadOk = false;
                    if (fromChangeTypeDocument) {
                      self.disabeldUploadFront[index] = false;
                      self.disabeldUploadBack[index] = false;
                    } else {
                      if (temp.length > 1) {
                        self.disabeldUploadFront[index] = false;
                        self.disabeldUploadBack[index] = false;
                        if (index == 0) {
                          self.userDaCensire.documento.imgDocumentoCfFront = "";
                          self.userDaCensire.documento.imgDocumentoCfBack = "";
                          self.userDaCensire.documento.idImgDocumentoCfFront =
                            "";
                          self.userDaCensire.documento.idImgDocumentoCfBack =
                            "";
                        } else if (index == 1) {
                          self.userDaCensire.documento.imgDocumentoBack = "";
                          self.userDaCensire.documento.imgDocumentoFront = "";
                          self.userDaCensire.documento.idImgDocumentoFront = "";
                          self.userDaCensire.documento.idImgDocumentoBack = "";
                        } else {
                          self.userDaCensire.documento.idImgDocumentoFrontOther =
                            "";
                          self.userDaCensire.documento.idImgDocumentoBackOther =
                            "";
                        }
                      } else {
                        if (temp[0].side && temp[0].side == "front") {
                          self.disabeldUploadFront[index] = false;
                          if (index == 0) {
                            self.userDaCensire.documento.imgDocumentoCfFront =
                              "";
                            self.userDaCensire.documento.idImgDocumentoCfFront =
                              "";
                          } else if (index == 1) {
                            self.userDaCensire.documento.imgDocumentoFront = "";
                            self.userDaCensire.documento.idImgDocumentoFront =
                              "";
                          } else {
                            self.userDaCensire.documento.idImgDocumentoFrontOther =
                              "";
                          }
                        } else {
                          self.disabeldUploadBack[index] = false;
                          if (index == 0) {
                            self.userDaCensire.documento.imgDocumentoCfBack =
                              "";
                            self.userDaCensire.documento.idImgDocumentoCfBack =
                              "";
                          } else if (index == 1) {
                            self.userDaCensire.documento.imgDocumentoBack = "";
                            self.userDaCensire.documento.idImgDocumentoBack =
                              "";
                          } else {
                            self.userDaCensire.documento.idImgDocumentoBackOther =
                              "";
                          }
                        }
                      }
                    }
                  }
                }
                if (type == "all") {
                  self.visualProgBarDoc[0] = false;
                  self.visualProgBarDoc[1] = false;
                } else {
                  self.visualProgBarDoc[index] = false;
                }
              })
              .catch(function (error) {
                $rootScope.$broadcast("addAlert", {
                  text: "ERROR_TEC",
                });
              });
          }
        });
      };

      self.startUploadDocument = function () {
        self.enableLoader = true;
        $rootScope.$broadcast("pageLoader", {
          action: "OPEN",
        });
        var checkOnlyTitolare =
          self.userDaCensire.titolare.selected &&
          !self.userDaCensire.firmatario.selected;
        var person = {
          cf: self.userDaCensire.cf,
          nome:
            self.userDaCensire.nome && self.userDaCensire.nome.toUpperCase(),
          cognome:
            self.userDaCensire.cognome &&
            self.userDaCensire.cognome.toUpperCase(),
          telefono: self.dealerUser.tel,
          documento: {
            tipo: self.userDaCensire.documento.tipo,
          },
          ndg: self.userDaCensire.ndg
        };

        self.intervalOfRepeatListenMobileCapture = 0;
        var numberOfIteration = 0;
        var person = [Pf.build(person)];

        if (self.isPostVendita) {
          $RichiestePostVenditaService
            .startMobileCapturePv(
              person,
              false,
              self.postVenditaModel.id,
              $configService.getUser().identifier,
              self.listOfDocument,
              true
            )
            .then(function (response) {
              if (response.success) {
                console.log(person);
                var inputListenMobileCapture = {
                  id: response.id,
                };

                var inputForCallBackMobileCapture = {
                  id: response.id,
                  contingencyUpload: self.documentUpload.filter(function (e) {
                    return e.type == "imgCf" || e.type == "imgDocument";
                  }),
                  flagCallFE: "false",
                  pv: true,
                };

                $instantService
                  .callbackMobileCapture(inputForCallBackMobileCapture)
                  .then(function (response) {
                    if (!response.success) {
                      $rootScope.$broadcast("pageLoader", {
                        action: "CLOSE",
                      });
                    } else {
                      self.intervalOfRepeatListenMobileCapture = setInterval(
                        function () {
                          $instantService
                            .listenMobileCapture(inputListenMobileCapture)
                            .then(function (response) {
                              numberOfIteration++;
                              if (
                                response.success &&
                                response.details.uploadCompleted
                              ) {
                                clearInterval(
                                  self.intervalOfRepeatListenMobileCapture
                                );
                                self.enableLoader = false;
                                $rootScope.$broadcast("pageLoader", {
                                  action: "CLOSE",
                                });
                                response.ocrResponse.cf = self.userDaCensire.cf;
                                response.ocrResponse.nome =
                                  self.userDaCensire.nome == "" ||
                                    self.userDaCensire.nome == null
                                    ? response.ocrResponse.nome
                                    : self.userDaCensire.nome;
                                response.ocrResponse.cognome =
                                  self.userDaCensire.cognome == "" ||
                                    self.userDaCensire.cognome == null
                                    ? response.ocrResponse.cognome
                                    : self.userDaCensire.cognome;
                                response.ocrResponse.sesso =
                                  self.userDaCensire.sesso;
                                response.ocrResponse.documento.enteRilascio =
                                  self.userDaCensire.documento.enteRilascio;
                                response.ocrResponse.documento.tipo =
                                  self.userDaCensire.documento.tipo;
                                /* uno */
                                response.ocrResponse.documento.dataRilascio =
                                  response.ocrResponse.documento.dataRilascio
                                    ? response.ocrResponse.documento
                                      .dataRilascio
                                    : self.userDaCensire.documento.dataRilascio;
                                response.ocrResponse.documento.dataScadenza =
                                  response.ocrResponse.documento.dataScadenza
                                    ? response.ocrResponse.documento
                                      .dataScadenza
                                    : self.userDaCensire.documento.dataScadenza;
                                response.ocrResponse.documento.luogoEsteso =
                                  response.ocrResponse.documento.luogoEsteso
                                    ? response.ocrResponse.documento.luogoEsteso
                                    : self.userDaCensire.documento.luogoEsteso;
                                response.ocrResponse.ndg =
                                  self.userDaCensire.ndg;
                                response.ocrResponse.documento.enteRilascio.name =
                                  response.ocrResponse.documento.enteRilascio
                                    .name
                                    ? response.ocrResponse.documento
                                      .enteRilascio.name
                                    : self.userDaCensire.documento.enteRilascio
                                      .name;
                                response.ocrResponse.documento.provincia =
                                  response.ocrResponse.documento.provincia
                                    ? response.ocrResponse.documento.provincia
                                    : self.userDaCensire.documento.provincia;
                                response.ocrResponse.documento.numero = response
                                  .ocrResponse.documento.numero
                                  ? response.ocrResponse.documento.numero
                                  : self.userDaCensire.documento.numero;

                                if (!response.ocrResponse.documento.statoEsteso) {
                                  response.ocrResponse.documento.statoEsteso = {};
                                }
                                response.ocrResponse.documento.statoEsteso.value = response.ocrResponse.documento.statoEsteso && response.ocrResponse.documento.statoEsteso.value ? response.ocrResponse.documento.statoEsteso.value : self.userDaCensire.documento.statoEsteso && self.userDaCensire.documento.statoEsteso.value;
                                response.ocrResponse.documento.statoEsteso.name = response.ocrResponse.documento.statoEsteso && response.ocrResponse.documento.statoEsteso.name ? response.ocrResponse.documento.statoEsteso.name : self.userDaCensire.documento.statoEsteso && self.userDaCensire.documento.statoEsteso.name;
                                response.ocrResponse.documento.statoEsteso.description = response.ocrResponse.documento.statoEsteso && response.ocrResponse.documento.statoEsteso.description ? response.ocrResponse.documento.statoEsteso.description : self.userDaCensire.documento.statoEsteso && self.userDaCensire.documento.statoEsteso.description;

                                /* due */
                                response.ocrResponse.datiNascita =
                                  self.userDaCensire.datiNascita;
                                response.ocrResponse.firmatario =
                                  self.userDaCensire.firmatario;
                                response.ocrResponse.titolare =
                                  self.userDaCensire.titolare;
                                response.ocrResponse.garante =
                                  self.userDaCensire.garante;

                                var luogoDocumento = self.mapComuni.filter(
                                  function (element) {
                                    if (
                                      !!response.ocrResponse.documento.luogo
                                    ) {
                                      return (
                                        element.nome.toUpperCase() ==
                                        response.ocrResponse.documento.luogo.toUpperCase()
                                      );
                                    } else if (
                                      response.ocrResponse.documento
                                        .luogoEsteso &&
                                      response.ocrResponse.documento.luogoEsteso
                                        .nome
                                    ) {
                                      return (
                                        element.nome.toUpperCase() ==
                                        response.ocrResponse.documento.luogoEsteso.nome.toUpperCase()
                                      );
                                    }
                                  }
                                );
                                if (
                                  self.userDaCensire.documento.provincia != "EE"
                                ) {
                                  response.ocrResponse.documento.luogoEsteso =
                                    luogoDocumento[0];
                                  response.ocrResponse.documento.provincia =
                                    luogoDocumento[0] &&
                                    luogoDocumento[0].sigla;
                                  response.ocrResponse.documento.luogo =
                                    response.ocrResponse.documento.luogo
                                      ? response.ocrResponse.documento.luogo
                                      : self.userDaCensire.documento.luogo;
                                } else {
                                  response.ocrResponse.documento.luogo =
                                    response.ocrResponse.documento.luogo
                                      ? response.ocrResponse.documento.luogo
                                      : self.userDaCensire.documento.luogo;
                                }

                                var luogoResidenza = self.mapComuni.filter(
                                  function (element) {
                                    return (
                                      element.nome.toUpperCase() ==
                                      response.ocrResponse.residenza.comune &&
                                      response.ocrResponse.residenza.comune.toUpperCase()
                                    );
                                  }
                                );
                                response.ocrResponse.residenza.luogoEsteso =
                                  luogoResidenza[0]
                                    ? luogoResidenza[0]
                                    : self.userDaCensire.residenza.luogoEsteso;
                                response.ocrResponse.residenza.provincia =
                                  luogoResidenza[0]
                                    ? luogoResidenza[0].sigla
                                    : self.userDaCensire.residenza.provincia;
                                response.ocrResponse.residenza.indirizzo =
                                  response.ocrResponse.residenza.indirizzo
                                    ? response.ocrResponse.residenza.indirizzo.split(
                                      ","
                                    )[0]
                                    : self.userDaCensire.residenza.indirizzo;
                                response.ocrResponse.residenza.numeroCivico =
                                  response.ocrResponse.residenza.numeroCivico
                                    ? response.ocrResponse.residenza
                                      .numeroCivico
                                    : self.userDaCensire.residenza.numeroCivico;
                                response.ocrResponse.residenza.cap =
                                  luogoResidenza[0]
                                    ? luogoResidenza[0].cap[0]
                                    : self.userDaCensire.residenza.cap;
                                response.ocrResponse.uploadMethod =
                                  self.uploadDocumentSelect;
                                response.ocrResponse.documento.idImgDocumentoBack =
                                  self.userDaCensire.documento.idImgDocumentoBack;
                                response.ocrResponse.documento.idImgDocumentoBackOther =
                                  self.userDaCensire.documento.idImgDocumentoBackOther;
                                response.ocrResponse.documento.idImgDocumentoCfBack =
                                  self.userDaCensire.documento.idImgDocumentoCfBack;
                                response.ocrResponse.documento.idImgDocumentoCfFront =
                                  self.userDaCensire.documento.idImgDocumentoCfFront;
                                response.ocrResponse.documento.idImgDocumentoFront =
                                  self.userDaCensire.documento.idImgDocumentoFront;
                                response.ocrResponse.documento.idImgDocumentoFrontOther =
                                  self.userDaCensire.documento.idImgDocumentoFrontOther;
                                response.ocrResponse.documento.idImgSubjectPhoto =
                                  self.userDaCensire.documento.idImgSubjectPhoto;
                                response.ocrResponse.ulterioreDocumento =
                                  self.userDaCensire.ulterioreDocumento;
                                response.ocrResponse.email =
                                  self.userDaCensire.email;
                                response.ocrResponse.telefono =
                                  self.userDaCensire.telefono;
                                response.ocrResponse.numDocumenti =
                                  self.userDaCensire.numDocumenti;
                                response.ocrResponse.deleted =
                                  self.userDaCensire.deleted;
                                response.ocrResponse.isEstero =
                                  self.userDaCensire.isEstero;

                                if (!response.ocrResponse.residenza.stato) {
                                  response.ocrResponse.residenza.stato = {};
                                }
                                response.ocrResponse.residenza.stato.value = response.ocrResponse.residenza.stato && response.ocrResponse.residenza.stato.value ? response.ocrResponse.residenza.stato.value : self.userDaCensire.residenza.stato && self.userDaCensire.residenza.stato.value;
                                response.ocrResponse.residenza.stato.name = response.ocrResponse.residenza.stato && response.ocrResponse.residenza.stato.name ? response.ocrResponse.residenza.stato.name : self.userDaCensire.residenza.stato && self.userDaCensire.residenza.stato.name;
                                response.ocrResponse.residenza.stato.description = response.ocrResponse.residenza.stato && response.ocrResponse.residenza.stato.description ? response.ocrResponse.residenza.stato.description : self.userDaCensire.residenza.stato && self.userDaCensire.residenza.stato.description;

                                if (!response.ocrResponse.residenza.statoEsteso) {
                                  response.ocrResponse.residenza.statoEsteso = {}
                                }

                                response.ocrResponse.residenza.statoEsteso.value = response.ocrResponse.residenza.statoEsteso && response.ocrResponse.residenza.statoEsteso.value ? response.ocrResponse.residenza.statoEsteso.value : self.userDaCensire.residenza.statoEsteso && self.userDaCensire.residenza.statoEsteso.value;
                                response.ocrResponse.residenza.statoEsteso.name = response.ocrResponse.residenza.statoEsteso && response.ocrResponse.residenza.statoEsteso.name ? response.ocrResponse.residenza.statoEsteso.name : self.userDaCensire.residenza.statoEsteso && self.userDaCensire.residenza.statoEsteso.name;
                                response.ocrResponse.residenza.statoEsteso.description = response.ocrResponse.residenza.statoEsteso && response.ocrResponse.residenza.statoEsteso.description ? response.ocrResponse.residenza.statoEsteso.description : self.userDaCensire.residenza.statoEsteso && self.userDaCensire.residenza.statoEsteso.description;
                                self.userDaCensire = Pf.build(
                                  response.ocrResponse
                                );
                                self.userDaCensire.documentiCaricati = true;
                                if (
                                  self.userDaCensire.residenza.luogoEsteso
                                    .nome == ""
                                ) {
                                  self.userDaCensire.residenza.luogoEsteso = "";
                                }
                                if (
                                  self.userDaCensire.datiNascita.luogoEsteso
                                    .nome == ""
                                ) {
                                  self.userDaCensire.datiNascita.luogoEsteso =
                                    "";
                                }
                                if (
                                  self.userDaCensire.documento.luogoEsteso
                                    .nome == ""
                                ) {
                                  self.userDaCensire.documento.luogoEsteso = "";
                                }
                              }
                              if (numberOfIteration >= 50) {
                                self.enableLoader = false;
                                $rootScope.$broadcast("pageLoader", {
                                  action: "CLOSE",
                                });

                                $rootScope.$broadcast("addAlert", {
                                  text: "ERROR_TIMEOUT_LISTEN_MOBILE",
                                });

                                clearInterval(
                                  self.intervalOfRepeatListenMobileCapture
                                );
                              }
                              console.log(
                                "Numero di iterazioni",
                                numberOfIteration
                              );
                              self.uploadFinish();
                              response.ocrResponse.documento.luogoEsteso &&
                                self.upgradeList({
                                  comune:
                                    self.userDaCensire.documento.luogoEsteso
                                      .nome,
                                });
                            })
                            .catch(function (error) {
                              console.log(error);
                              self.enableLoader = false;
                              $rootScope.$broadcast("pageLoader", {
                                action: "CLOSE",
                              });
                            });
                        },
                        10000
                      );
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                    self.enableLoader = false;
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE",
                    });

                    $rootScope.$broadcast("addAlert", {
                      text: "ERROR_TIMEOUT_LISTEN_MOBILE",
                    });
                  });
              } else {
                $rootScope.$broadcast("pageLoader", {
                  action: "CLOSE",
                });
              }
            })
            .catch(function (error) {
              console.log(error);
              self.showLoader = false;
              $rootScope.$broadcast("pageLoader", {
                action: "CLOSE",
              });
            })
            .finally(function () { });
        } else {
          $financialApiService
            .startMobileCaptureDigital(
              person,
              self.vendorPhone,
              false,
              self.financialModel.leasingData.id,
              self.financialModel.financialCustomer.metadata.riUserG.cf,
              self.financialModel.financialVendor.riUserG.cf,
              self.listOfDocument
            )
            .then(function (response) {
              if (response.success) {
                var inputListenMobileCapture = {
                  id: response.id,
                };

                var inputForCallBackMobileCapture = {
                  id: response.id,
                  contingencyUpload: self.documentUpload.filter(function (e) {
                    return e.type == "imgCf" || e.type == "imgDocument";
                  }),
                  flagCallFE: "false",
                  financial: true,
                  anno: self.financialModel.leasingData.preventivo.anno.toString(),
                  numero:
                    self.financialModel.leasingData.preventivo.numero.toString(),
                };

                $instantService
                  .callbackMobileCapture(inputForCallBackMobileCapture)
                  .then(function (response) {
                    if (!response.success) {
                      $rootScope.$broadcast("pageLoader", {
                        action: "CLOSE",
                      });
                    } else {
                      self.intervalOfRepeatListenMobileCapture = setInterval(
                        function () {
                          $instantService
                            .listenMobileCapture(inputListenMobileCapture)
                            .then(function (response) {
                              numberOfIteration++;
                              if (
                                response.success &&
                                response.details.uploadCompleted
                              ) {
                                clearInterval(
                                  self.intervalOfRepeatListenMobileCapture
                                );
                                self.enableLoader = false;
                                $rootScope.$broadcast("pageLoader", {
                                  action: "CLOSE",
                                });
                                response.ocrResponse.cf = self.userDaCensire.cf;
                                response.ocrResponse.nome =
                                  self.userDaCensire.nome == "" ||
                                    self.userDaCensire.nome == null
                                    ? response.ocrResponse.nome
                                    : self.userDaCensire.nome;
                                response.ocrResponse.cognome =
                                  self.userDaCensire.cognome == "" ||
                                    self.userDaCensire.cognome == null
                                    ? response.ocrResponse.cognome
                                    : self.userDaCensire.cognome;
                                response.ocrResponse.sesso =
                                  self.userDaCensire.sesso;
                                response.ocrResponse.documento.enteRilascio =
                                  self.userDaCensire.documento.enteRilascio;
                                response.ocrResponse.documento.tipo =
                                  self.userDaCensire.documento.tipo;
                                /* uno */
                                response.ocrResponse.documento.dataRilascio =
                                  response.ocrResponse.documento.dataRilascio
                                    ? response.ocrResponse.documento
                                      .dataRilascio
                                    : self.userDaCensire.documento.dataRilascio;
                                response.ocrResponse.documento.dataScadenza =
                                  response.ocrResponse.documento.dataScadenza
                                    ? response.ocrResponse.documento
                                      .dataScadenza
                                    : self.userDaCensire.documento.dataScadenza;
                                response.ocrResponse.documento.luogoEsteso =
                                  response.ocrResponse.documento.luogoEsteso
                                    ? response.ocrResponse.documento.luogoEsteso
                                    : self.userDaCensire.documento.luogoEsteso;

                                response.ocrResponse.documento.enteRilascio.name =
                                  response.ocrResponse.documento.enteRilascio
                                    .name
                                    ? response.ocrResponse.documento
                                      .enteRilascio.name
                                    : self.userDaCensire.documento.enteRilascio
                                      .name;
                                response.ocrResponse.documento.provincia =
                                  response.ocrResponse.documento.provincia
                                    ? response.ocrResponse.documento.provincia
                                    : self.userDaCensire.documento.provincia;
                                response.ocrResponse.documento.numero = response
                                  .ocrResponse.documento.numero
                                  ? response.ocrResponse.documento.numero
                                  : self.userDaCensire.documento.numero;

                                if (!response.ocrResponse.documento.statoEsteso) {
                                  response.ocrResponse.documento.statoEsteso = {};
                                }

                                response.ocrResponse.documento.statoEsteso.value = response.ocrResponse.documento.statoEsteso && response.ocrResponse.documento.statoEsteso.value ? response.ocrResponse.documento.statoEsteso.value : self.userDaCensire.documento.statoEsteso && self.userDaCensire.documento.statoEsteso.value;
                                response.ocrResponse.documento.statoEsteso.name = response.ocrResponse.documento.statoEsteso && response.ocrResponse.documento.statoEsteso.name ? response.ocrResponse.documento.statoEsteso.name : self.userDaCensire.documento.statoEsteso && self.userDaCensire.documento.statoEsteso.name;
                                response.ocrResponse.documento.statoEsteso.description = response.ocrResponse.documento.statoEsteso && response.ocrResponse.documento.statoEsteso.description ? response.ocrResponse.documento.statoEsteso.description : self.userDaCensire.documento.statoEsteso && self.userDaCensire.documento.statoEsteso.description;
                                /* due */
                                response.ocrResponse.datiNascita =
                                  self.userDaCensire.datiNascita;
                                response.ocrResponse.firmatario =
                                  self.userDaCensire.firmatario;
                                response.ocrResponse.titolare =
                                  self.userDaCensire.titolare;
                                response.ocrResponse.garante =
                                  self.userDaCensire.garante;

                                var luogoDocumento = self.mapComuni.filter(
                                  function (element) {
                                    if (
                                      !!response.ocrResponse.documento.luogo
                                    ) {
                                      return (
                                        element.nome.toUpperCase() ==
                                        response.ocrResponse.documento.luogo.toUpperCase()
                                      );
                                    } else if (
                                      response.ocrResponse.documento
                                        .luogoEsteso &&
                                      response.ocrResponse.documento.luogoEsteso
                                        .nome
                                    ) {
                                      return (
                                        element.nome.toUpperCase() ==
                                        response.ocrResponse.documento.luogoEsteso.nome.toUpperCase()
                                      );
                                    }
                                  }
                                );
                                response.ocrResponse.documento.luogoEsteso =
                                  luogoDocumento[0];
                                if (self.userDaCensire.isEstero) {
                                  response.ocrResponse.documento.provincia =
                                    self.userDaCensire.documento.provincia;
                                } else {
                                  if (
                                    self.userDaCensire.documento.provincia !=
                                    "EE"
                                  ) {
                                    response.ocrResponse.documento.luogoEsteso =
                                      luogoDocumento[0];
                                    response.ocrResponse.documento.provincia =
                                      luogoDocumento[0] &&
                                      luogoDocumento[0].sigla;
                                    response.ocrResponse.documento.luogo =
                                      response.ocrResponse.documento.luogo
                                        ? response.ocrResponse.documento.luogo
                                        : self.userDaCensire.documento.luogo;
                                  } else {
                                    response.ocrResponse.documento.luogo =
                                      response.ocrResponse.documento.luogo
                                        ? response.ocrResponse.documento.luogo
                                        : self.userDaCensire.documento.luogo;
                                  }
                                }

                                var luogoResidenza = self.mapComuni.filter(
                                  function (element) {
                                    return (
                                      element.nome.toUpperCase() ==
                                      response.ocrResponse.residenza.comune &&
                                      response.ocrResponse.residenza.comune.toUpperCase()
                                    );
                                  }
                                );
                                response.ocrResponse.residenza.luogoEsteso =
                                  luogoResidenza[0]
                                    ? luogoResidenza[0]
                                    : self.userDaCensire.residenza.luogoEsteso;
                                response.ocrResponse.residenza.provincia =
                                  luogoResidenza[0]
                                    ? luogoResidenza[0].sigla
                                    : self.userDaCensire.residenza.provincia;
                                response.ocrResponse.residenza.indirizzo =
                                  response.ocrResponse.residenza.indirizzo
                                    ? response.ocrResponse.residenza.indirizzo.split(
                                      ","
                                    )[0]
                                    : self.userDaCensire.residenza.indirizzo;
                                response.ocrResponse.residenza.numeroCivico =
                                  response.ocrResponse.residenza.numeroCivico
                                    ? response.ocrResponse.residenza
                                      .numeroCivico
                                    : self.userDaCensire.residenza.numeroCivico;
                                response.ocrResponse.residenza.cap =
                                  luogoResidenza[0]
                                    ? luogoResidenza[0].cap[0]
                                    : self.userDaCensire.residenza.cap;
                                response.ocrResponse.uploadMethod =
                                  self.uploadDocumentSelect;
                                response.ocrResponse.documento.idImgDocumentoBack =
                                  self.userDaCensire.documento.idImgDocumentoBack;
                                response.ocrResponse.documento.idImgDocumentoBackOther =
                                  self.userDaCensire.documento.idImgDocumentoBackOther;
                                response.ocrResponse.documento.idImgDocumentoCfBack =
                                  self.userDaCensire.documento.idImgDocumentoCfBack;
                                response.ocrResponse.documento.idImgDocumentoCfFront =
                                  self.userDaCensire.documento.idImgDocumentoCfFront;
                                response.ocrResponse.documento.idImgDocumentoFront =
                                  self.userDaCensire.documento.idImgDocumentoFront;
                                response.ocrResponse.documento.idImgDocumentoFrontOther =
                                  self.userDaCensire.documento.idImgDocumentoFrontOther;
                                response.ocrResponse.documento.idImgSubjectPhoto =
                                  self.userDaCensire.documento.idImgSubjectPhoto;
                                response.ocrResponse.ulterioreDocumento =
                                  self.userDaCensire.ulterioreDocumento;
                                response.ocrResponse.email =
                                  self.userDaCensire.email;
                                response.ocrResponse.telefono =
                                  self.userDaCensire.telefono;
                                response.ocrResponse.numDocumenti =
                                  self.userDaCensire.numDocumenti;
                                response.ocrResponse.deleted =
                                  self.userDaCensire.deleted;
                                response.ocrResponse.isEstero =
                                  self.userDaCensire.isEstero;
                                response.ocrResponse.ndg =
                                  self.userDaCensire.ndg;
                                response.ocrResponse.residenza.cap = response
                                  .ocrResponse.residenza.cap
                                  ? response.ocrResponse.residenza.cap
                                  : self.userDaCensire.residenza.cap;
                                response.ocrResponse.residenza.comune = response
                                  .ocrResponse.residenza.comune
                                  ? response.ocrResponse.residenza.comune
                                  : self.userDaCensire.residenza.comune;
                                response.ocrResponse.residenza.indirizzo =
                                  response.ocrResponse.residenza.indirizzo
                                    ? response.ocrResponse.residenza.indirizzo
                                    : self.userDaCensire.residenza.indirizzo;
                                response.ocrResponse.residenza.numeroCivico =
                                  response.ocrResponse.residenza.numeroCivico
                                    ? response.ocrResponse.residenza
                                      .numeroCivico
                                    : self.userDaCensire.residenza.numeroCivico;

                                if (!response.ocrResponse.residenza.stato) {
                                  response.ocrResponse.residenza.stato = {};
                                }
                                response.ocrResponse.residenza.stato.value = response.ocrResponse.residenza.stato && response.ocrResponse.residenza.stato.value ? response.ocrResponse.residenza.stato.value : self.userDaCensire.residenza.stato && self.userDaCensire.residenza.stato.value;
                                response.ocrResponse.residenza.stato.name = response.ocrResponse.residenza.stato && response.ocrResponse.residenza.stato.name ? response.ocrResponse.residenza.stato.name : self.userDaCensire.residenza.stato && self.userDaCensire.residenza.stato.name;
                                response.ocrResponse.residenza.stato.description = response.ocrResponse.residenza.stato && response.ocrResponse.residenza.stato.description ? response.ocrResponse.residenza.stato.description : self.userDaCensire.residenza.stato && self.userDaCensire.residenza.stato.description;

                                if (!response.ocrResponse.residenza.statoEsteso) {
                                  response.ocrResponse.residenza.statoEsteso = {}
                                }

                                response.ocrResponse.residenza.statoEsteso.value = response.ocrResponse.residenza.statoEsteso && response.ocrResponse.residenza.statoEsteso.value ? response.ocrResponse.residenza.statoEsteso.value : self.userDaCensire.residenza.statoEsteso && self.userDaCensire.residenza.statoEsteso.value;
                                response.ocrResponse.residenza.statoEsteso.name = response.ocrResponse.residenza.statoEsteso && response.ocrResponse.residenza.statoEsteso.name ? response.ocrResponse.residenza.statoEsteso.name : self.userDaCensire.residenza.statoEsteso && self.userDaCensire.residenza.statoEsteso.name;
                                response.ocrResponse.residenza.statoEsteso.description = response.ocrResponse.residenza.statoEsteso && response.ocrResponse.residenza.statoEsteso.description ? response.ocrResponse.residenza.statoEsteso.description : self.userDaCensire.residenza.statoEsteso && self.userDaCensire.residenza.statoEsteso.description;

                                self.userDaCensire = Pf.build(
                                  response.ocrResponse
                                );
                                if (
                                  self.userDaCensire.isEstero &&
                                  self.userDaCensire.residenza.stato.name.toUpperCase() ==
                                  "ITALIA"
                                ) {
                                  self.userDaCensire.residenza.stato = null;
                                }
                                self.userDaCensire.documentiCaricati = true;
                                if (
                                  self.userDaCensire.residenza.luogoEsteso
                                    .nome == ""
                                ) {
                                  self.userDaCensire.residenza.luogoEsteso = "";
                                }
                                if (
                                  self.userDaCensire.datiNascita.luogoEsteso
                                    .nome == ""
                                ) {
                                  self.userDaCensire.datiNascita.luogoEsteso =
                                    "";
                                }
                                if (
                                  self.userDaCensire.documento.luogoEsteso
                                    .nome == ""
                                ) {
                                  self.userDaCensire.documento.luogoEsteso = "";
                                }
                              }
                              if (numberOfIteration >= 50) {
                                self.enableLoader = false;
                                $rootScope.$broadcast("pageLoader", {
                                  action: "CLOSE",
                                });

                                $rootScope.$broadcast("addAlert", {
                                  text: "ERROR_TIMEOUT_LISTEN_MOBILE",
                                });

                                clearInterval(
                                  self.intervalOfRepeatListenMobileCapture
                                );
                              }
                              console.log(
                                "Numero di iterazioni",
                                numberOfIteration
                              );
                              self.uploadFinish();
                              response.ocrResponse.documento.luogoEsteso &&
                                self.upgradeList({
                                  comune:
                                    self.userDaCensire.documento.luogoEsteso
                                      .nome,
                                });
                            })
                            .catch(function (error) {
                              console.log(error);
                              self.enableLoader = false;
                              $rootScope.$broadcast("pageLoader", {
                                action: "CLOSE",
                              });
                            });
                        },
                        10000
                      );
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                    self.enableLoader = false;
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE",
                    });

                    $rootScope.$broadcast("addAlert", {
                      text: "ERROR_TIMEOUT_LISTEN_MOBILE",
                    });
                  });
              } else {
                $rootScope.$broadcast("pageLoader", {
                  action: "CLOSE",
                });
              }
            })
            .catch(function (error) {
              console.log(error);
              self.showLoader = false;
              $rootScope.$broadcast("pageLoader", {
                action: "CLOSE",
              });
            })
            .finally(function () { });
        }
      };

      self.startUploadDocumentMobile = function () {
        self.enableLoader = true;
        $rootScope.$broadcast("pageLoader", {
          action: "OPEN",
        });
        self.documentUpload = [];
        var checkOnlyTitolare =
          self.userDaCensire.titolare.selected &&
          !self.userDaCensire.firmatario.selected;
        var person = {
          cf: self.userDaCensire.cf,
          nome:
            self.userDaCensire.nome && self.userDaCensire.nome.toUpperCase(),
          cognome:
            self.userDaCensire.cognome &&
            self.userDaCensire.cognome.toUpperCase(),
          telefono: self.dealerUser.tel,
          documento: {
            tipo: self.userDaCensire.documento.tipo,
          },
          ndg: self.userDaCensire.ndg
        };

        self.intervalOfRepeatListenMobileCapture = 0;
        var numberOfIteration = 0;
        var person = [Pf.build(person)];

        if (self.isPostVendita) {
          $RichiestePostVenditaService
            .startMobileCapturePv(
              person,
              true,
              self.postVenditaModel.id,
              $configService.getUser().identifier,
              self.listOfDocument
            )
            .then(function (response) {
              if (response.success) {
                var inputListenMobileCapture = {
                  id: response.id,
                };

                self.intervalOfRepeatListenMobileCapture = setInterval(
                  function () {
                    $instantService
                      .listenMobileCapture(inputListenMobileCapture)
                      .then(function (response) {
                        numberOfIteration++;
                        if (
                          response.success &&
                          response.details.uploadCompleted
                        ) {
                          clearInterval(
                            self.intervalOfRepeatListenMobileCapture
                          );
                          self.enableLoader = false;
                          $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE",
                          });
                          response.ocrResponse.cf = self.userDaCensire.cf;
                          response.ocrResponse.nome =
                            self.userDaCensire.nome == ""
                              ? response.ocrResponse.nome
                              : self.userDaCensire.nome;
                          response.ocrResponse.cognome =
                            self.userDaCensire.cognome == ""
                              ? response.ocrResponse.cognome
                              : self.userDaCensire.cognome;
                          response.ocrResponse.sesso = self.userDaCensire.sesso;
                          response.ocrResponse.documento.enteRilascio =
                            self.userDaCensire.documento.enteRilascio;
                          response.ocrResponse.documento.tipo =
                            self.userDaCensire.documento.tipo;
                          response.ocrResponse.ndg = self.userDaCensire.ndg;
                          response.ocrResponse.documento.dataRilascio = response
                            .ocrResponse.documento.dataRilascio
                            ? response.ocrResponse.documento.dataRilascio
                            : self.userDaCensire.documento.dataRilascio;
                          response.ocrResponse.documento.dataScadenza = response
                            .ocrResponse.documento.dataScadenza
                            ? response.ocrResponse.documento.dataScadenza
                            : self.userDaCensire.documento.dataScadenza;
                          response.ocrResponse.documento.luogoEsteso = response
                            .ocrResponse.documento.luogoEsteso
                            ? response.ocrResponse.documento.luogoEsteso
                            : self.userDaCensire.documento.luogoEsteso;
                          response.ocrResponse.documento.enteRilascio.name =
                            response.ocrResponse.documento.enteRilascio.name
                              ? response.ocrResponse.documento.enteRilascio.name
                              : self.userDaCensire.documento.enteRilascio.name;
                          response.ocrResponse.documento.provincia = response
                            .ocrResponse.documento.provincia
                            ? response.ocrResponse.documento.provincia
                            : self.userDaCensire.documento.provincia;
                          response.ocrResponse.documento.numero = response
                            .ocrResponse.documento.numero
                            ? response.ocrResponse.documento.numero
                            : self.userDaCensire.documento.numero;

                          response.ocrResponse.datiNascita =
                            self.userDaCensire.datiNascita;
                          response.ocrResponse.firmatario =
                            self.userDaCensire.firmatario;
                          response.ocrResponse.titolare =
                            self.userDaCensire.titolare;
                          response.ocrResponse.garante =
                            self.userDaCensire.garante;

                          var luogoDocumento = self.mapComuni.filter(function (
                            element
                          ) {
                            return (
                              element.nome.toUpperCase() ==
                              response.ocrResponse.documento.luogo &&
                              response.ocrResponse.documento.luogo.toUpperCase()
                            );
                          });
                          if (self.userDaCensire.documento.provincia != "EE") {
                            response.ocrResponse.documento.luogoEsteso =
                              luogoDocumento[0];
                            response.ocrResponse.documento.provincia =
                              luogoDocumento[0] && luogoDocumento[0].sigla;
                            response.ocrResponse.documento.luogo = response
                              .ocrResponse.documento.luogo
                              ? response.ocrResponse.documento.luogo
                              : self.userDaCensire.documento.luogo;
                          } else {
                            response.ocrResponse.documento.luogo = response
                              .ocrResponse.documento.luogo
                              ? response.ocrResponse.documento.luogo
                              : self.userDaCensire.documento.luogo;
                          }

                          var luogoResidenza = self.mapComuni.filter(function (
                            element
                          ) {
                            return (
                              element.nome.toUpperCase() ==
                              response.ocrResponse.residenza.comune &&
                              response.ocrResponse.residenza.comune.toUpperCase()
                            );
                          });
                          response.ocrResponse.residenza.luogoEsteso =
                            luogoResidenza[0]
                              ? luogoResidenza[0]
                              : self.userDaCensire.residenza.luogoEsteso;
                          response.ocrResponse.residenza.provincia =
                            luogoResidenza[0]
                              ? luogoResidenza[0].sigla
                              : self.userDaCensire.residenza.provincia;
                          response.ocrResponse.residenza.indirizzo = response
                            .ocrResponse.residenza.indirizzo
                            ? response.ocrResponse.residenza.indirizzo.split(
                              ","
                            )[0]
                            : self.userDaCensire.residenza.indirizzo;
                          response.ocrResponse.residenza.numeroCivico = response
                            .ocrResponse.residenza.numeroCivico
                            ? response.ocrResponse.residenza.numeroCivico
                            : self.userDaCensire.residenza.numeroCivico;
                          response.ocrResponse.ulterioreDocumento =
                            self.userDaCensire.ulterioreDocumento;
                          response.ocrResponse.email = self.userDaCensire.email;
                          response.ocrResponse.telefono =
                            self.userDaCensire.telefono;
                          response.ocrResponse.numDocumenti =
                            self.userDaCensire.numDocumenti;
                          response.ocrResponse.deleted =
                            self.userDaCensire.deleted;
                          response.ocrResponse.isEstero =
                            self.userDaCensire.isEstero;
                          self.userDaCensire = Pf.build(response.ocrResponse);
                          self.userDaCensire.documentiCaricati = true;
                          if (
                            self.userDaCensire.residenza.luogoEsteso.nome == ""
                          ) {
                            self.userDaCensire.residenza.luogoEsteso = "";
                          }
                          if (
                            self.userDaCensire.datiNascita.luogoEsteso.nome ==
                            ""
                          ) {
                            self.userDaCensire.datiNascita.luogoEsteso = "";
                          }
                          if (
                            self.userDaCensire.documento.luogoEsteso.nome == ""
                          ) {
                            self.userDaCensire.documento.luogoEsteso = "";
                          }
                          self.documentUpload = [];
                          var temp = {
                            name: response.ocrResponse.documento
                              .imgDocumentoCfFront,
                            type: "imgCf",
                            selected: false,
                            side: "front",
                            typeDocument: "CF",
                            cdDoc: "CF",
                            id: response.ocrResponse.documento
                              .idImgDocumentoCfFront,
                            downloadKey:
                              response.ocrResponse.documento
                                .idImgDocumentoCfFront,
                          };
                          self.documentUpload.push(temp);
                          var temp = {
                            name: response.ocrResponse.documento
                              .imgDocumentoCfBack,
                            type: "imgCf",
                            selected: false,
                            side: "back",
                            typeDocument: "CF",
                            cdDoc: "CF",
                            id: response.ocrResponse.documento
                              .idImgDocumentoCfBack,
                            downloadKey:
                              response.ocrResponse.documento
                                .idImgDocumentoCfBack,
                          };
                          self.documentUpload.push(temp);

                          var temp = {
                            name: response.ocrResponse.documento
                              .imgDocumentoFront,
                            type: "imgDocument",
                            selected: false,
                            side: "front",
                            typeDocument: self.userDaCensire.documento.tipo,
                            cdDoc: self.userDaCensire.documento.tipo,
                            id: response.ocrResponse.documento
                              .idImgDocumentoFront,
                            downloadKey:
                              response.ocrResponse.documento
                                .idImgDocumentoFront,
                          };
                          self.documentUpload.push(temp);
                          var temp = {
                            name: response.ocrResponse.documento
                              .imgDocumentoBack,
                            type: "imgDocument",
                            selected: false,
                            side: "back",
                            typeDocument: self.userDaCensire.documento.tipo,
                            cdDoc: self.userDaCensire.documento.tipo,
                            id: response.ocrResponse.documento
                              .idImgDocumentoBack,
                            downloadKey:
                              response.ocrResponse.documento.idImgDocumentoBack,
                          };
                          self.documentUpload.push(temp);

                          if (
                            response.ocrResponse.documento
                              .idImgDocumentoBackOther
                          ) {
                            var temp = {
                              name: "Ulteriore documento retro",
                              type: "imgOtherDocument",
                              selected: false,
                              side: "back",
                              typeDocument:
                                self.userDaCensire.ulterioreDocumento.tipo,
                              cdDoc: self.userDaCensire.ulterioreDocumento.tipo,
                              id: response.ocrResponse.documento
                                .idImgDocumentoBackOther,
                              downloadKey:
                                response.ocrResponse.documento
                                  .idImgDocumentoBackOther,
                            };
                            self.documentUpload.push(temp);
                          }
                          if (
                            response.ocrResponse.documento
                              .idImgDocumentoFrontOther
                          ) {
                            var temp = {
                              name: "Ulteriore documento fronte",
                              type: "imgOtherDocument",
                              selected: false,
                              side: "front",
                              typeDocument:
                                self.userDaCensire.ulterioreDocumento.tipo,
                              cdDoc: self.userDaCensire.ulterioreDocumento.tipo,
                              id: response.ocrResponse.documento
                                .idImgDocumentoFrontOther,
                              downloadKey:
                                response.ocrResponse.documento
                                  .idImgDocumentoFrontOther,
                            };
                            self.documentUpload.push(temp);
                          }
                          if (
                            response.ocrResponse.documento.idImgSubjectPhoto
                          ) {
                            var temp = {
                              name: "Selfie",
                              type: "foto",
                              selected: false,
                              side: "front",
                              typeDocument: "foto",
                              cdDoc: "foto",
                              id: response.ocrResponse.documento
                                .idImgSubjectPhoto,
                              downloadKey:
                                response.ocrResponse.documento
                                  .idImgSubjectPhoto,
                            };
                            self.documentUpload.push(temp);
                          }
                        }
                        if (numberOfIteration >= 50) {
                          self.enableLoader = false;
                          $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE",
                          });

                          $rootScope.$broadcast("addAlert", {
                            text: "ERROR_TIMEOUT_LISTEN_MOBILE",
                          });

                          clearInterval(
                            self.intervalOfRepeatListenMobileCapture
                          );
                        }
                        console.log("Numero di iterazioni", numberOfIteration);
                        self.uploadFinish();
                        response.ocrResponse &&
                          self.upgradeList({
                            comune:
                              self.userDaCensire.documento.luogoEsteso.nome,
                          });
                      })
                      .catch(function (error) {
                        console.log(error);
                        self.enableLoader = false;
                        $rootScope.$broadcast("pageLoader", {
                          action: "CLOSE",
                        });
                      });
                  },
                  10000
                );
              } else {
                $rootScope.$broadcast("pageLoader", {
                  action: "CLOSE",
                });
              }
            })
            .catch(function (error) {
              console.log(error);
              self.showLoader = false;
              self.enableLoader = false;
              $rootScope.$broadcast("pageLoader", {
                action: "CLOSE",
              });
            })
            .finally(function () { });
        } else {
          $financialApiService
            .startMobileCaptureDigital(
              person,
              self.vendorPhone,
              true,
              self.financialModel.leasingData.id,
              self.financialModel.financialCustomer.metadata.riUserG.cf,
              self.financialModel.financialVendor.riUserG.cf,
              self.listOfDocument
            )
            .then(function (response) {
              if (response.success) {
                var inputListenMobileCapture = {
                  id: response.id,
                };

                self.intervalOfRepeatListenMobileCapture = setInterval(
                  function () {
                    $instantService
                      .listenMobileCapture(inputListenMobileCapture)
                      .then(function (response) {
                        numberOfIteration++;
                        if (
                          response.success &&
                          response.details.uploadCompleted
                        ) {
                          clearInterval(
                            self.intervalOfRepeatListenMobileCapture
                          );
                          self.enableLoader = false;
                          $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE",
                          });
                          response.ocrResponse.cf = self.userDaCensire.cf;
                          response.ocrResponse.nome =
                            self.userDaCensire.nome == ""
                              ? response.ocrResponse.nome
                              : self.userDaCensire.nome;
                          response.ocrResponse.cognome =
                            self.userDaCensire.cognome == ""
                              ? response.ocrResponse.cognome
                              : self.userDaCensire.cognome;
                          response.ocrResponse.sesso = self.userDaCensire.sesso;
                          response.ocrResponse.documento.enteRilascio =
                            self.userDaCensire.documento.enteRilascio;
                          response.ocrResponse.documento.tipo =
                            self.userDaCensire.documento.tipo;

                          response.ocrResponse.documento.dataRilascio = response
                            .ocrResponse.documento.dataRilascio
                            ? response.ocrResponse.documento.dataRilascio
                            : self.userDaCensire.documento.dataRilascio;
                          response.ocrResponse.documento.dataScadenza = response
                            .ocrResponse.documento.dataScadenza
                            ? response.ocrResponse.documento.dataScadenza
                            : self.userDaCensire.documento.dataScadenza;
                          response.ocrResponse.documento.luogoEsteso = response
                            .ocrResponse.documento.luogoEsteso
                            ? response.ocrResponse.documento.luogoEsteso
                            : self.userDaCensire.documento.luogoEsteso;
                          response.ocrResponse.documento.enteRilascio.name =
                            response.ocrResponse.documento.enteRilascio.name
                              ? response.ocrResponse.documento.enteRilascio.name
                              : self.userDaCensire.documento.enteRilascio.name;
                          response.ocrResponse.documento.provincia = response
                            .ocrResponse.documento.provincia
                            ? response.ocrResponse.documento.provincia
                            : self.userDaCensire.documento.provincia;
                          response.ocrResponse.documento.numero = response
                            .ocrResponse.documento.numero
                            ? response.ocrResponse.documento.numero
                            : self.userDaCensire.documento.numero;

                          response.ocrResponse.datiNascita =
                            self.userDaCensire.datiNascita;
                          response.ocrResponse.firmatario =
                            self.userDaCensire.firmatario;
                          response.ocrResponse.titolare =
                            self.userDaCensire.titolare;
                          response.ocrResponse.garante =
                            self.userDaCensire.garante;

                          var luogoDocumento = self.mapComuni.filter(function (
                            element
                          ) {
                            return (
                              element.nome.toUpperCase() ==
                              response.ocrResponse.documento.luogo &&
                              response.ocrResponse.documento.luogo.toUpperCase()
                            );
                          });
                          if (self.isEstero) {
                            response.ocrResponse.documento.provincia =
                              self.userDaCensire.documento.provincia;
                          } else {
                            if (
                              self.userDaCensire.documento.provincia != "EE"
                            ) {
                              response.ocrResponse.documento.luogoEsteso =
                                luogoDocumento[0];
                              response.ocrResponse.documento.provincia =
                                luogoDocumento[0] && luogoDocumento[0].sigla;
                              response.ocrResponse.documento.luogo = response
                                .ocrResponse.documento.luogo
                                ? response.ocrResponse.documento.luogo
                                : self.userDaCensire.documento.luogo;
                            } else {
                              response.ocrResponse.documento.luogo = response
                                .ocrResponse.documento.luogo
                                ? response.ocrResponse.documento.luogo
                                : self.userDaCensire.documento.luogo;
                            }
                          }

                          var luogoResidenza = self.mapComuni.filter(function (
                            element
                          ) {
                            return (
                              element.nome.toUpperCase() ==
                              response.ocrResponse.residenza.comune &&
                              response.ocrResponse.residenza.comune.toUpperCase()
                            );
                          });
                          response.ocrResponse.residenza.luogoEsteso =
                            luogoResidenza[0]
                              ? luogoResidenza[0]
                              : self.userDaCensire.residenza.luogoEsteso;
                          response.ocrResponse.residenza.provincia =
                            luogoResidenza[0]
                              ? luogoResidenza[0].sigla
                              : self.userDaCensire.residenza.provincia;
                          response.ocrResponse.residenza.indirizzo = response
                            .ocrResponse.residenza.indirizzo
                            ? response.ocrResponse.residenza.indirizzo.split(
                              ","
                            )[0]
                            : self.userDaCensire.residenza.indirizzo;
                          response.ocrResponse.residenza.numeroCivico = response
                            .ocrResponse.residenza.numeroCivico
                            ? response.ocrResponse.residenza.numeroCivico
                            : self.userDaCensire.residenza.numeroCivico;
                          response.ocrResponse.ulterioreDocumento =
                            self.userDaCensire.ulterioreDocumento;
                          response.ocrResponse.email = self.userDaCensire.email;
                          response.ocrResponse.telefono =
                            self.userDaCensire.telefono;
                          response.ocrResponse.numDocumenti =
                            self.userDaCensire.numDocumenti;
                          response.ocrResponse.deleted =
                            self.userDaCensire.deleted;
                          response.ocrResponse.isEstero =
                            self.userDaCensire.isEstero;
                          response.ocrResponse.ndg = self.userDaCensire.ndg;
                          response.ocrResponse.residenza.cap = response
                            .ocrResponse.residenza.cap
                            ? response.ocrResponse.residenza.cap
                            : self.userDaCensire.residenza.cap;
                          response.ocrResponse.residenza.comune = response
                            .ocrResponse.residenza.comune
                            ? response.ocrResponse.residenza.comune
                            : self.userDaCensire.residenza.comune;
                          self.userDaCensire = Pf.build(response.ocrResponse);
                          self.userDaCensire.documentiCaricati = true;
                          if (
                            self.userDaCensire.residenza.luogoEsteso.nome == ""
                          ) {
                            self.userDaCensire.residenza.luogoEsteso = "";
                          }
                          if (
                            self.userDaCensire.datiNascita.luogoEsteso.nome ==
                            ""
                          ) {
                            self.userDaCensire.datiNascita.luogoEsteso = "";
                          }
                          if (
                            self.userDaCensire.documento.luogoEsteso.nome == ""
                          ) {
                            self.userDaCensire.documento.luogoEsteso = "";
                          }
                          self.documentUpload = [];
                          var temp = {
                            name: response.ocrResponse.documento
                              .imgDocumentoCfFront,
                            type: "imgCf",
                            selected: false,
                            side: "front",
                            typeDocument: "CF",
                            cdDoc: "CF",
                            id: response.ocrResponse.documento
                              .idImgDocumentoCfFront,
                            downloadKey:
                              response.ocrResponse.documento
                                .idImgDocumentoCfFront,
                          };
                          self.documentUpload.push(temp);
                          var temp = {
                            name: response.ocrResponse.documento
                              .imgDocumentoCfBack,
                            type: "imgCf",
                            selected: false,
                            side: "back",
                            typeDocument: "CF",
                            cdDoc: "CF",
                            id: response.ocrResponse.documento
                              .idImgDocumentoCfBack,
                            downloadKey:
                              response.ocrResponse.documento
                                .idImgDocumentoCfBack,
                          };
                          self.documentUpload.push(temp);

                          var temp = {
                            name: response.ocrResponse.documento
                              .imgDocumentoFront,
                            type: "imgDocument",
                            selected: false,
                            side: "front",
                            typeDocument: self.userDaCensire.documento.tipo,
                            cdDoc: self.userDaCensire.documento.tipo,
                            id: response.ocrResponse.documento
                              .idImgDocumentoFront,
                            downloadKey:
                              response.ocrResponse.documento
                                .idImgDocumentoFront,
                          };
                          self.documentUpload.push(temp);
                          var temp = {
                            name: response.ocrResponse.documento
                              .imgDocumentoBack,
                            type: "imgDocument",
                            selected: false,
                            side: "back",
                            typeDocument: self.userDaCensire.documento.tipo,
                            cdDoc: self.userDaCensire.documento.tipo,
                            id: response.ocrResponse.documento
                              .idImgDocumentoBack,
                            downloadKey:
                              response.ocrResponse.documento.idImgDocumentoBack,
                          };
                          self.documentUpload.push(temp);

                          if (
                            response.ocrResponse.documento
                              .idImgDocumentoBackOther
                          ) {
                            var temp = {
                              name: "Ulteriore documento retro",
                              type: "imgOtherDocument",
                              selected: false,
                              side: "back",
                              typeDocument:
                                self.userDaCensire.ulterioreDocumento.tipo,
                              cdDoc: self.userDaCensire.ulterioreDocumento.tipo,
                              id: response.ocrResponse.documento
                                .idImgDocumentoBackOther,
                              downloadKey:
                                response.ocrResponse.documento
                                  .idImgDocumentoBackOther,
                            };
                            self.documentUpload.push(temp);
                          }
                          if (
                            response.ocrResponse.documento
                              .idImgDocumentoFrontOther
                          ) {
                            var temp = {
                              name: "Ulteriore documento fronte",
                              type: "imgOtherDocument",
                              selected: false,
                              side: "front",
                              typeDocument:
                                self.userDaCensire.ulterioreDocumento.tipo,
                              cdDoc: self.userDaCensire.ulterioreDocumento.tipo,
                              id: response.ocrResponse.documento
                                .idImgDocumentoFrontOther,
                              downloadKey:
                                response.ocrResponse.documento
                                  .idImgDocumentoFrontOther,
                            };
                            self.documentUpload.push(temp);
                          }
                          if (
                            response.ocrResponse.documento.idImgSubjectPhoto
                          ) {
                            var temp = {
                              name: "Selfie",
                              type: "foto",
                              selected: false,
                              side: "front",
                              typeDocument: "foto",
                              cdDoc: "foto",
                              id: response.ocrResponse.documento
                                .idImgSubjectPhoto,
                              downloadKey:
                                response.ocrResponse.documento
                                  .idImgSubjectPhoto,
                            };
                            self.documentUpload.push(temp);
                          }
                        }
                        if (numberOfIteration >= 50) {
                          self.enableLoader = false;
                          $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE",
                          });

                          $rootScope.$broadcast("addAlert", {
                            text: "ERROR_TIMEOUT_LISTEN_MOBILE",
                          });

                          clearInterval(
                            self.intervalOfRepeatListenMobileCapture
                          );
                        }
                        console.log("Numero di iterazioni", numberOfIteration);
                        self.uploadFinish();
                        response.ocrResponse &&
                          self.upgradeList({
                            comune:
                              self.userDaCensire.documento.luogoEsteso.nome,
                          });
                      })
                      .catch(function (error) {
                        console.log(error);
                        self.enableLoader = false;
                        $rootScope.$broadcast("pageLoader", {
                          action: "CLOSE",
                        });
                      });
                  },
                  10000
                );
              } else {
                $rootScope.$broadcast("pageLoader", {
                  action: "CLOSE",
                });
              }
            })
            .catch(function (error) {
              console.log(error);
              self.showLoader = false;
              self.enableLoader = false;
              $rootScope.$broadcast("pageLoader", {
                action: "CLOSE",
              });
            })
            .finally(function () { });
        }
      };

      self.callStartMobile = function () {
        if (self.uploadFromSmartphone) {
          self.startUploadDocumentMobile();
        } else {
          self.startUploadDocument();
        }

        self.unlockDocumentFields = true; // abilitazione a porcedere quando tutto è andata bene
      };

      self.check = function (el) {
        el.selected = !el.selected;
      };

      self.trashCanEnabledCf = function () {
        return self.documentUpload.some(function (elem) {
          return elem.selected === true && elem.type == "imgCf";
        });
      };
      self.trashCanEnabledDoc = function (value) {
        return self.documentUpload.some(function (elem) {
          return elem.selected === true && elem.type == value;
        });
      };

      self.getListaDocumenti = function () {
        self.waitForRest = true;
        $typeDomainService
          .getDomainSet("RI_DROPDOWN_DOMAINS", "DOCUMENT_TYPE")
          .then(function (response) {
            self.dropdown.tipiDocumento = response.domainList;
            for (i = 0; i < self.dropdown.tipiDocumento.length; i++) {
              if (self.dropdown.tipiDocumento[i].value == "CAE") {
                self.dropdown.tipiDocumento[i].order = 40;
              }
              if (self.dropdown.tipiDocumento[i].value == "CAI") {
                self.dropdown.tipiDocumento[i].order = 10;
              }
              if (self.dropdown.tipiDocumento[i].value == "CIE") {
                self.dropdown.tipiDocumento[i].order = 20;
              }
              if (self.dropdown.tipiDocumento[i].value == "NCE") {
                self.dropdown.tipiDocumento[i].order = 30;
              }
              if (self.dropdown.tipiDocumento[i].value == "PAM") {
                self.dropdown.tipiDocumento[i].order = 50;
              }
              if (self.dropdown.tipiDocumento[i].value == "PAS") {
                self.dropdown.tipiDocumento[i].order = 80;
              }
              if (self.dropdown.tipiDocumento[i].value == "PAT") {
                self.dropdown.tipiDocumento[i].order = 60;
              }
              if (self.dropdown.tipiDocumento[i].value == "UCO") {
                self.dropdown.tipiDocumento[i].order = 70;
              }
            }
            self.dropdown.ulterioriTipiDocumento = self.dropdown.tipiDocumento;
            listOfDocument = self.dropdown.ulterioriTipiDocumento;
          });

        if (self.isPostVendita) {
          $financialApiService
            .getDocAttesiForPerson(
              self.userDaCensire,
              false,
              false,
              self.postVenditaModel.idWf
            )
            .then(function (response) {
              self.listOfDocumentChecklist =
                response.personalDocsChecklist.uploadedFiles;
              self.genericDocsChecklist =
                response.genericDocsChecklist.uploadedFiles;
              self.personalDocsGarChecklist =
                response.personalDocsGarChecklist.uploadedFiles;
              if (self.postVenditaModel && self.hideCf) {
                self.listOfDocument =
                  response.personalDocConfig &&
                  response.personalDocConfig.filter(function (element) {
                    return element.id != "tessera_sanitaria";
                  });
              } else {
                self.listOfDocument = response.personalDocConfig;
              }
              self.userDaCensire.numDocumenti = self.listOfDocument.length;
              self.listOfDocument.forEach(function (e) {
                if (e.id == "tessera_sanitaria") {
                  e.id = "imgCf";
                }
                if (e.id == "doc_identita" && e.label == "DOC_IDENTITA_LBL") {
                  e.id = "imgDocument";
                } else if (
                  e.id == "doc_identita" &&
                  e.label == "DOC_IDENTITA2_LBL"
                ) {
                  e.id = "imgOtherDocument";
                }
              });
              if (self.$portalService.isAru() || self.snapshot) {
                self.addDocument.selected = true;
              } else {
                self.addDocument.selected = false;
              }
              if (
                self.listOfDocumentChecklist.length <= 0 &&
                self.$portalService.isAra() &&
                self.genericDocsChecklist.length <= 0
              ) {
                self.hideListOfElementUploaded = true;
              } else {
                self.hideListOfElementUploaded = false;
              }
              self.waitForRest = false;
            })
            .catch(function (error) {
              self.waitForRest = false;
            });
        } else {
          $financialApiService
            .getDocAttesiForPerson(
              self.userDaCensire,
              self.financialModel.leasingData.preventivo.firmaDigitale,
              self.financialModel.leasingData.preventivo.firmaDigitaleEsterna,
              self.financialModel.leasingData.id
            )
            .then(function (response) {
              self.listOfDocumentChecklist =
                response.personalDocsChecklist.uploadedFiles;
              self.genericDocsChecklist =
                response.genericDocsChecklist.uploadedFiles;
              self.personalDocsGarChecklist =
                response.personalDocsGarChecklist.uploadedFiles;
              self.listOfDocument = response.personalDocConfig;
              self.userDaCensire.numDocumenti = self.listOfDocument.length;
              self.listOfDocument.forEach(function (e) {
                if (e.id == "tessera_sanitaria") {
                  e.id = "imgCf";
                }
                if (e.id == "doc_identita" && e.label == "DOC_IDENTITA_LBL") {
                  e.id = "imgDocument";
                } else if (
                  e.id == "doc_identita" &&
                  e.label == "DOC_IDENTITA2_LBL"
                ) {
                  e.id = "imgOtherDocument";
                }
              });
              if (
                self.$portalService.isAru() ||
                self.snapshot
              ) {
                self.addDocument.selected = true;
              } else {
                self.addDocument.selected = false;
              }
              if (
                self.listOfDocumentChecklist.length <= 0 &&
                self.$portalService.isAra() &&
                self.genericDocsChecklist.length <= 0
              ) {
                self.hideListOfElementUploaded = true;
              } else {
                self.hideListOfElementUploaded = false;
              }
              self.waitForRest = false;
            })
            .catch(function (error) {
              self.waitForRest = false;
            });
        }
      };
      self.enableButton = function () {
        if (self.listOfDocument && self.listOfDocument.length) {
          var numberOFDocument = self.listOfDocument.length * 2;
          if (numberOFDocument == self.documentUpload.length) {
            return true;
          } else {
            return false;
          }

        } else {
          return false;
        }
      };

      self.uploadSelected = function () {
        self.deletePrivacyDocument("all");
        // self.disabeldUploadBack = [];
        // self.disabeldUploadFront = [];
        if (self.uploadDocumentSelect === "smartphone") {
          self.uploadFromSmartphone = true;
        } else {
          self.uploadFromSmartphone = false;
          self.vendorPhone = "";
        }
        self.userDaCensire.uploadMethod = self.uploadDocumentSelect;
      };

      self.enableButtonMobile = function () {
        if (self.$portalService.isAru()) {
          self.vendorPhone = true;
        }
        return self.uploadFromSmartphone && self.userDaCensire.documento.tipo;
      };

      self.setDocNumRegex = function (tipoDocumento, index) {
        var documento = self.dropdown.tipiDocumento.find(x => {
          return x.value == tipoDocumento
        })
        self.showDownloadExample = documento && documento.additionalProperty == 1 ? true : false;
        generateLinkExampleDoc(tipoDocumento);
        if (self.$portalService.isAra() && self.userDaCensire.ndg) {
          $financialApiService
            .getIdentityDocument(
              self.userDaCensire.ndg,
              self.userDaCensire.documento.tipo
            )
            .then(function (response) {
              if (response.success && response.document) {
                self.userDaCensire.documento.dataRilascio =
                  response.document.dataRilascio;
                self.userDaCensire.documento.dataScadenza =
                  response.document.dataScadenza;
                if (response.document.provincia == 'EE' || response.document.provincia == 'SE') {
                  self.userDaCensire.documento.luogo = response.document.luogo;

                  if (self.userDaCensire.isEstero) {
                    self.userDaCensire.documento.statoEsteso = {
                      name: response.document.luogo
                    }
                  }


                } else {
                  self.userDaCensire.documento.luogoEsteso = {
                    nome: response.document.luogo,
                  };
                }
                self.userDaCensire.documento.enteRilascio.name =
                  response.document.enteRilascio;
                self.userDaCensire.documento.provincia =
                  response.document.provincia;
                self.userDaCensire.documento.numero = response.document.numero;
                self.userDaCensire.documento.id = response.document.id;
                self.upgradeList({
                  comune: response.document.luogo,
                });
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
        removeElementoOfOtherList(tipoDocumento, index);

        if (
          index == 1 ||
          (self.postVenditaModel)
        ) {
          var isPresentDocument = self.documentUpload.filter(function (e) {
            return e.type == "imgDocument";
          });
          var enableAllInputButton = true;
          if (isPresentDocument.length > 0) {
            self.documentUpload.forEach(function (element) {
              if (element.type == "imgDocument") {
                element.selected = true;
              }
            });
            self.userDaCensire.documento.imgDocumentoBack = "";
            self.userDaCensire.documento.imgDocumentoFront = "";
            self.deletePrivacyDocument(
              "imgDocument",
              index,
              enableAllInputButton
            );
          }
        } else {
          var isPresentDocument = self.documentUpload.filter(function (e) {
            return e.type == "imgOtherDocument";
          });
          var enableAllInputButton = true;
          if (isPresentDocument.length > 0) {
            self.documentUpload.forEach(function (element) {
              if (element.type == "imgOtherDocument") {
                element.selected = true;
              }
            });
            self.userDaCensire.documento.idImgDocumentoFrontOther = "";
            self.userDaCensire.documento.idImgDocumentoBackOther = "";
            self.deletePrivacyDocument(
              "imgOtherDocument",
              index,
              enableAllInputButton
            );
          }
        }

        self.uploadFinish({ fromChangeDoc: true });
      };

      var removeElementoOfOtherList = function (tipoDocumento, index) {
        self.dropdown.ulterioriTipiDocumento = listOfDocument;
        self.dropdown.tipiDocumento = listOfDocument;

        self.dropdown.ulterioriTipiDocumento =
          self.dropdown.ulterioriTipiDocumento.filter(function (element) {
            if (
              self.userDaCensire.documento.tipo == "CAI" ||
              self.userDaCensire.documento.tipo == "NCE" ||
              self.userDaCensire.documento.tipo == "CIE"
            ) {
              return (
                element.value != "CAI" &&
                element.value != "NCE" &&
                element.value != "CIE"
              );
            } else if (
              self.userDaCensire.documento.tipo == "PAM" ||
              self.userDaCensire.documento.tipo == "PAT" ||
              self.userDaCensire.documento.tipo == "UCO"
            ) {
              return (
                element.value != "PAT" &&
                element.value != "PAM" &&
                element.value != "UCO"
              );
            } else {
              return element.value != self.userDaCensire.documento.tipo;
            }
          });

        self.dropdown.tipiDocumento = self.dropdown.tipiDocumento.filter(
          function (element) {
            if (
              self.userDaCensire.ulterioreDocumento.tipo == "CAI" ||
              self.userDaCensire.ulterioreDocumento.tipo == "NCE" ||
              self.userDaCensire.ulterioreDocumento.tipo == "CIE"
            ) {
              return (
                element.value != "CAI" &&
                element.value != "NCE" &&
                element.value != "CIE"
              );
            } else if (
              self.userDaCensire.ulterioreDocumento.tipo == "PAM" ||
              self.userDaCensire.ulterioreDocumento.tipo == "PAT" ||
              self.userDaCensire.ulterioreDocumento.tipo == "UCO"
            ) {
              return (
                element.value != "PAT" &&
                element.value != "PAM" &&
                element.value != "UCO"
              );
            } else {
              return (
                element.value != self.userDaCensire.ulterioreDocumento.tipo
              );
            }
          }
        );
      };

      var generateLinkExampleDoc = function (tipoDocumento) {
        self.linkDownloadExampleDoc = $configService.getAppConfig().url +
          '/uni/download/service-infos/' +
          encodeURIComponent(tipoDocumento) +
          '/?token=' +
          $configService.getAppConfig().token;
      }
    },
  });